<div [class.meu-local-page]="!isDialog">
  <mat-card [class.no-shadow]="isDialog">
    <mat-card-content>
      <div class="titulo" *ngIf="!isDialog">
        <mat-icon>my_location</mat-icon>
        <h2>Meu Local</h2>
      </div>

      <p class="descricao">
        Selecione o local que você comanda. Ele será usado no botão
        <strong>“Iniciar no meu local”</strong>.
      </p>

      <div *ngIf="localAtual" class="local-atual">
        <mat-icon>place</mat-icon>
        <span>Local atual: <strong>{{ localAtual.name }}</strong></span>
      </div>

      <div *ngIf="isLoading" class="loading">
        <mat-spinner diameter="32"></mat-spinner>
        <span>Carregando locais...</span>
      </div>

      <div *ngIf="error" class="error">{{ error }}</div>

      <ng-container *ngIf="!isLoading && !error">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Local que você comanda</mat-label>
          <mat-select [(ngModel)]="selectedLocationUuid">
            <mat-optgroup *ngFor="let job of jobs" [label]="job.name">
              <mat-option *ngFor="let loc of job.locationList" [value]="loc.locationUuid">
                {{ loc.name }}
              </mat-option>
            </mat-optgroup>
          </mat-select>
        </mat-form-field>

        <div class="acoes">
          <button mat-raised-button color="primary" type="button"
                  [disabled]="!selectedLocationUuid" (click)="salvar()">
            <mat-icon>save</mat-icon>
            Salvar
          </button>

          <button *ngIf="!isDialog && localAtual" mat-stroked-button color="warn" type="button" (click)="limpar()">
            <mat-icon>delete</mat-icon>
            Remover
          </button>

          <button *ngIf="isDialog" mat-button type="button" (click)="pular()">
            Deixar em branco
          </button>
        </div>
      </ng-container>
    </mat-card-content>
  </mat-card>
</div>
